import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';

const EditMultipleProductModal = (props) => {
    console.log(props , 'props check edit stock price')

    return (
        <div>
            {props.messageAddModal && props.messageAddModal ? <p style={{color : 'green' , fontSize : 12}}>{props.messageAddModal} </p> : '' }
            <Form>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Sizes</Form.Label>
                <Form.Select aria-label="Default select example" 
                    defaultValue={props.editStockPriceMrp && props.editStockPriceMrp.size_id}
                onChange={(e) => props.setEditStockPriceMrp({...props.editStockPriceMrp , size_id:e.target.value})}>
                        <option disabled> Select Product Size</option>
                    {props.productSize && props.productSize.map((item,index) => {
                        return (
                            <option key={index} value={item.size_id}>{item.size_name}</option>
                        );
                        })
                    }
                </Form.Select>
                {props && props.errorAddModal ? <p  style={{color : 'red' , fontSize : 12}}>{props.errorAddModal.size}</p> : '' }
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Product MRP</Form.Label>
                    <Form.Control type="text" defaultValue={props.editStockPriceMrp && props.editStockPriceMrp.mrp }
                        onChange={(e) => props.setEditStockPriceMrp({...props.editStockPriceMrp , mrp:e.target.value})}
                    />
                    {props && props.errorAddModal ? <p  style={{color : 'red' , fontSize : 12}}>{props.errorAddModal.mrp}</p> : '' }
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Product Price</Form.Label>
                <Form.Control type="text" defaultValue={props.editStockPriceMrp && props.editStockPriceMrp.price }
                      onChange={(e) => props.setEditStockPriceMrp({...props.editStockPriceMrp , price:e.target.value})}

                />
                    {props && props.errorAddModal ? <p  style={{color : 'red' , fontSize : 12}}>{props.errorAddModal.price}</p> : '' }
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Product Stock</Form.Label>
                <Form.Control type="text" defaultValue={props.editStockPriceMrp && props.editStockPriceMrp.stock } 
                      onChange={(e) => props.setEditStockPriceMrp({...props.editStockPriceMrp , stock:e.target.value})}
                />
                    {props && props.errorAddModal ? <p  style={{color : 'red' , fontSize : 12}}>{props.errorAddModal.stock}</p> : '' }
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInputSKU">
                <Form.Label>SKU Code (Optional)</Form.Label>
                <Form.Control type="text" defaultValue={props.editStockPriceMrp && props.editStockPriceMrp.sku } 
                      placeholder="e.g. SKU-1001"
                      onChange={(e) => props.setEditStockPriceMrp({...props.editStockPriceMrp , sku:e.target.value})}
                />
                    {props && props.errorAddModal ? <p  style={{color : 'red' , fontSize : 12}}>{props.errorAddModal.sku}</p> : '' }
                </Form.Group>
            </Form>
        </div>
    );
};

export default EditMultipleProductModal;